<div class="market-time">
   <span class="timezone">
      {{this.timezone}}: 
   </span>
   <span class="time">
      {{this.time}}
   </span>
</div>